var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3876 7.42123L12.8583 0.686644C12.6618 0.388699 12.3309 0.25 12 0.25C11.6691 0.25 11.3382 0.393836 11.1417 0.686644L6.61239 7.42123H1.65909C1.09034 7.42123 0.625 7.88356 0.625 8.44863C0.625 8.54623 0.640511 8.6387 0.661193 8.72603L3.28261 18.25C3.52562 19.113 4.32705 19.75 5.27841 19.75H18.7216C19.673 19.75 20.4744 19.113 20.7122 18.2449L23.3336 8.72089C23.3595 8.6387 23.375 8.54623 23.375 8.44863C23.375 7.88356 22.9097 7.42123 22.3409 7.42123H17.3876ZM8.89773 7.42123L12 2.90068L15.1023 7.42123H8.89773ZM12 15.6404C10.8573 15.6404 9.93182 14.7209 9.93182 13.5856C9.93182 12.4503 10.8573 11.5308 12 11.5308C13.1427 11.5308 14.0682 12.4503 14.0682 13.5856C14.0682 14.7209 13.1427 15.6404 12 15.6404Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.a3bd4986bc98555e26b3e2aa1291844a.svg";
export { ForwardRef as ReactComponent };